'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/yearFromNow.js